import React from 'react'

const MultipleChoice = ({ data, handleAnswer, answers }) => {
    return (
        <div className="multi__ques">
            {data.options.map((subQuestion, subIndex) => (
                <div key={subIndex} className="sub__question">
                    <p>{subQuestion.question}</p>
                    <div className="multi__ques__options">
                        {subQuestion.options.map((option, index) => (
                            <button
                                key={index}
                                className={`option ${answers?.[data.id]?.[subQuestion.id] ===
                                    option.label
                                    ? "selected"
                                    : ""
                                    }`}
                                onClick={() =>
                                    handleAnswer(subQuestion.id, option.label)
                                }
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default MultipleChoice